import { Component, OnInit } from '@angular/core';

import {
  DialogLayoutDisplay,
  DialogInitializer,
  ButtonLayoutDisplay,
  ButtonMaker,
  AppearanceAnimation,
  DisappearanceAnimation
} from '@costlydeveloper/ngx-awesome-popup';
import { Router } from '@angular/router';
import { DialogStartCashRegisterComponent } from '../dialog-start-cash-register/dialog-start-cash-register.component';
import { DialogContinueSessionComponent } from '../dialog-continue-session/dialog-continue-session.component';
import { faFileInvoiceDollar, faXmark } from '@fortawesome/pro-light-svg-icons';
import { CashRegisterService } from '../../services/cash-register.service';

@Component({
  selector: 'app-select-cash-register',
  templateUrl: './select-cash-register.component.html',
  styleUrls: ['./select-cash-register.component.scss']
})
export class SelectCashRegisterComponent implements OnInit {

  cashRegisters: any = [];
  cashRegisterSelected: number = 0;
  faReport = faFileInvoiceDollar;
  faXmark = faXmark;
  id_business: any;

  constructor(private cashRegisterService: CashRegisterService, private router: Router) { }

  ngOnInit() {

    // if(localStorage.getItem("id_work_time") !== null) {
    //   this.router.navigate(['home']);
    // }
    this.id_business = localStorage.getItem('id_business');

    this.cashRegisterService.getCashRegistersByBussiness(this.id_business).subscribe({
      next: (res) => {
        this.cashRegisters = res.data.filter((cashRegister: any) => cashRegister.status === true);
      }
    })
  }

  close() {
    window.close();
  }

  viewReports() {
    this.router.navigateByUrl("/cash-register-report")
  }


  selectCashRegister(cashRegister: any) {
    this.cashRegisterSelected = cashRegister.id;
    let work_time_cash_registers = cashRegister.work_time_cash_registers?.find((work_time: any) => !work_time.closed);
    if (work_time_cash_registers) {
      const dialogPopup = new DialogInitializer(DialogContinueSessionComponent);

      // Any data can be sent to AnyAngularComponent.
      dialogPopup.setCustomData({ 'id_cash_register': cashRegister.id, 'cash_name': cashRegister.name });

      // Set some configuration.
      dialogPopup.setConfig({
        width: '500px',
        layoutType: DialogLayoutDisplay.NONE, // SUCCESS | INFO | NONE | DANGER | WARNING
        animationIn: AppearanceAnimation.NONE,
        animationOut: DisappearanceAnimation.NONE,
        escapeKeyClose: true,

      });

      // Simply open the popup and observe which button is clicked and,
      // receive optional payload from AnyAngularComponent.
      dialogPopup.openDialog$().subscribe(resp => {
      });

    } else {
      let data = { 'id_cash_register': cashRegister.id, 'initial_balance': 500 }

      const dialogPopup = new DialogInitializer(DialogStartCashRegisterComponent);

      // Any data can be sent to AnyAngularComponent.
      dialogPopup.setCustomData({ 'id_cash_register': cashRegister.id, 'cash_name': cashRegister.name });

      // Set some configuration.
      dialogPopup.setConfig({
        width: '855px',
        layoutType: DialogLayoutDisplay.NONE, // SUCCESS | INFO | NONE | DANGER | WARNING
        animationIn: AppearanceAnimation.NONE,
        animationOut: DisappearanceAnimation.NONE,
        escapeKeyClose: true,

      });

      // Set some custom buttons as list.
      // SUCCESS | INFO | NONE | DANGER | WARNING | PRIMARY | SECONDARY | LINK | DARK | LIGHT
      dialogPopup.setButtons([
        new ButtonMaker('Cancelar', 'cancel', ButtonLayoutDisplay.SECONDARY),
        new ButtonMaker('Confirmar', 'submit', ButtonLayoutDisplay.SUCCESS)
      ]);

      // Simply open the popup and observe which button is clicked and,
      // receive optional payload from AnyAngularComponent.
      dialogPopup.openDialog$().subscribe(resp => {
      });
    }
  }

}
